import React, { useCallback, useContext, useEffect, useMemo, useRef } from 'react'
import { RouteComponentProps } from 'react-router'
import ModalContext from 'contexts/ModalContext'
import { useIsMobileDevice } from 'hooks/useIsMobileDevice'
import WrappedStoryContainer from './Components/WrappedStoryContainer'
import { pushWithRegion } from 'actions/NavigationActions'
import { useAppDispatch } from 'hooks/reduxHooks'

interface RouteParams {
  userId?: string
}

type Props = RouteComponentProps<RouteParams | undefined>

function WrappedPage({ match }: Props) {
  const showModal = useContext(ModalContext)
  const isMobile = useIsMobileDevice()
  const uuid = match?.params?.userId

  const dispatch = useAppDispatch()
  const hasShownModalRef = useRef(false)
  const isCancelledRef = useRef(false)

  const handleClose = useCallback(() => {
    dispatch(pushWithRegion('/'))
  }, [dispatch])

  const modalContent = useMemo(
    () => <WrappedStoryContainer uuid={uuid} />,
    [uuid],
  )

  const openDesktopModal = useCallback(async() => {
    await showModal(modalContent)
    if (!isCancelledRef.current) {
      dispatch(pushWithRegion('/'))
    }
  }, [showModal, modalContent, dispatch])

  useEffect(() => {
    isCancelledRef.current = false

    if (!isMobile && !hasShownModalRef.current) {
      hasShownModalRef.current = true
      openDesktopModal()
    }

    return () => {
      isCancelledRef.current = true
    }
  }, [isMobile, openDesktopModal])

  if (isMobile) {
    return <WrappedStoryContainer uuid={uuid} mode="fullPage" onClose={handleClose} />
  }

  return null
}

export default WrappedPage
